import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import {
  type ChatConversationExternalAction,
  type ChatEntityLinkAdapter,
  type ChatEntityReference,
} from 'ias-ppr-mt-chat-client';

@Injectable()
export class AscupChatEntityLinkAdapter implements ChatEntityLinkAdapter {
  private readonly router = inject(Router);

  public getNavigationHref(target: ChatEntityReference): string | null {
    switch (target.type) {
      case 'ias-ppr:protocol-template':
        return this.router.serializeUrl(
          this.router.createUrlTree([
            '/dispatching/protocol-template',
            target.id,
          ]),
        );
      case 'ias-ppr:NNR':
        return this.router.serializeUrl(
          this.router.createUrlTree(['/event/disruption', target.id]),
        );
      case 'ias-ppr:SB':
        return this.router.serializeUrl(
          this.router.createUrlTree(['/event/security', target.id]),
        );
      default:
        return null;
    }
  }

  public getResourceUrl(_target: ChatEntityReference): string | null {
    return null;
  }

  public executeAction(action: ChatConversationExternalAction): boolean {
    if (action.semantic !== 'navigate') {
      return false;
    }

    const href = this.getNavigationHref(action.payload);
    if (!href) {
      return false;
    }

    void this.router.navigateByUrl(href);
    return true;
  }
}
